/** Testi di M7/M8: impostazioni, contatti operativi, email inviate, registro, cancellazioni, dettaglio utente, i tuoi dati. */
export const amministrazione = {
  nav: 'Impostazioni',
  titolo: 'Impostazioni',
  sottotitolo: 'Contatti operativi, conservazione dei dati, email inviate, registro degli eventi e richieste di cancellazione.',
  schede: { contatti: 'Contatti operativi', retention: 'Conservazione e default', email: 'Email inviate', registro: 'Registro eventi', cancellazioni: 'Richieste di cancellazione' },

  contatti: {
    intro: 'Chi riceve il report Excel, gli avvisi via email e le chiamate se la piattaforma non risponde durante un webinar. Ogni modifica finisce nel registro.',
    nuovo: 'Aggiungi contatto',
    nuovoTitolo: 'Nuovo contatto operativo',
    modificaTitolo: (nome: string) => `Modifica ${nome}`,
    salva: 'Salva il contatto',
    salvato: 'Contatto salvato.',
    disattiva: 'Disattiva',
    disattivaTitolo: (nome: string) => `Disattivare ${nome}?`,
    disattivaTesto: 'Non riceverà più report, avvisi né chiamate. Resta nel registro e si può riattivare modificandolo.',
    disattivaConferma: 'Sì, disattiva',
    disattivato: 'Contatto disattivato.',
    avvisoReport: 'Nessun contatto attivo riceve il report: alla chiusura di un test l’Excel andrebbe solo all’organizzatore del percorso.',
    avvisoChiamate: 'Servono almeno due contatti attivi per le chiamate: in caso di allarme durante un webinar nessuno verrebbe chiamato.',
    nessunoTitolo: 'Nessun contatto operativo',
    nessunoTesto: 'Aggiungi almeno l’organizzatore (riceve il report) e due persone reperibili (ricevono le chiamate).',
    colonne: { ruolo: 'Ruolo', nome: 'Nome', email: 'Email', telefono: 'Telefono', riceve: 'Riceve', attivo: 'Attivo', note: 'Note' },
    ruoli: { organizzatore: 'Organizzatore', segreteria: 'Segreteria / staff di sala', responsabile_tecnico: 'Responsabile tecnico', devops: 'DevOps / reperibilità', regia: 'Regia della sala', dpo: 'DPO', altro: 'Altro' } as const,
    campi: {
      ruolo: 'Ruolo',
      nome: 'Nome e cognome',
      email: 'Email',
      telefono: 'Telefono',
      telefonoAiuto: 'In formato internazionale, es. +39 333 1234567 senza spazi.',
      riceveReport: 'Riceve il report Excel',
      riceveAvvisi: 'Riceve gli avvisi via email',
      riceveChiamate: 'Riceve chiamate e SMS in caso di allarme',
      attivoDal: 'Attivo dal',
      attivoAl: 'Attivo fino al',
      attivoAlAiuto: 'Lascia vuoto se non ha una scadenza.',
      note: 'Note',
    },
    badge: { report: 'Report', avvisi: 'Avvisi', chiamate: 'Chiamate', nessuno: 'Niente' },
    stati: { attivo: 'Attivo', disattivato: 'Disattivato' },
  },

  retention: {
    intro: 'Dopo questi giorni i dati vengono cancellati o resi anonimi in automatico, ogni notte. La cancellazione è irreversibile: il DPO può allungare i termini, non recuperare ciò che è già stato cancellato.',
    categorie: { presenze: 'Presenze (ingressi, uscite, minuti)', esiti_test: 'Esiti del test', attestati: 'Attestati e codici di verifica', domande_pubblico: 'Domande del pubblico', log_accessi: 'Accessi, dispositivi, indirizzi IP', email_log: 'Log delle email inviate' } as const,
    giorni: 'Giorni',
    giorniAiuto: 'Da 30 a 3650 (dieci anni).',
    prossima: (tipo: string, quando: string, n: number) => `Prossima cancellazione automatica: ${tipo}, ${quando} (${n} elementi).`,
    nessunaProssima: 'Al momento nessun dato è in scadenza.',
    defaultTitolo: 'Default dei nuovi webinar',
    defaultTesto: 'Valori proposti alla creazione di un webinar: si possono cambiare webinar per webinar.',
    soglia: 'Soglia di presenza per il test (%)',
    durataTest: 'Durata del test (minuti)',
    finestraTest: 'Finestra del test dopo la diretta (ore)',
    corretteMinime: 'Risposte corrette minime',
    domandeTitolo: 'Domande del pubblico',
    maxPerWebinar: 'Massimo domande per partecipante e webinar',
    ogniSecondi: 'Secondi minimi tra due domande',
    salva: 'Salva le impostazioni',
    salvato: 'Impostazioni salvate.',
    nonValido: 'Controlla i valori evidenziati.',
  },

  email: {
    intro: 'Tutte le email inviate dalla piattaforma: codici, inviti, promemoria, attestati, report.',
    colonne: { destinatario: 'Destinatario', oggetto: 'Oggetto', template: 'Tipo', stato: 'Stato', data: 'Data' },
    stati: { in_coda: 'In coda', inviata: 'Inviata', errore: 'Errore' } as const,
    filtroTemplate: 'Tipo',
    template: { verifica_email: 'Verifica email', nuovo_dispositivo: 'Nuovo dispositivo', completa_iscrizione: 'Completa iscrizione', iscrizione_percorso: 'Iscrizione al percorso', invito_webinar: 'Invito al webinar', promemoria_webinar: 'Promemoria', attestato_pronto: 'Attestato pronto', report_webinar: 'Report del webinar' } as Record<string, string>,
    reinvia: 'Reinvia',
    reinviaTitolo: 'Reinviare questa email?',
    reinviaTesto: (to: string) => `L’email verrà inviata di nuovo a ${to}. I codici temporanei non si reinviano: per quelli l’utente usa "Rinvia il codice".`,
    reinviaConferma: 'Sì, reinvia',
    reinviata: 'Email rimessa in coda.',
    nessunaTitolo: 'Nessuna email',
    nessunaTesto: 'Le email compaiono qui appena la piattaforma le invia.',
    nessunRisultato: 'Nessuna email corrisponde ai filtri.',
    cercaAiuto: 'Destinatario o oggetto',
    senzaOggetto: '(senza oggetto)',
  },

  registro: {
    intro: 'Ogni azione rilevante, in ordine di tempo, con una catena di impronte che rende evidente qualsiasi manomissione.',
    colonne: { quando: 'Data e ora', chi: 'Chi', azione: 'Azione', soggetto: 'Soggetto', ip: 'IP' },
    filtroAzione: 'Azione',
    filtroAzioneAiuto: 'Es. accesso, diretta_avviata, presenza_corretta',
    cercaAiuto: 'Nome, azione o identificativo',
    sistema: 'Sistema',
    dettagli: 'Dettagli',
    nascondi: 'Nascondi i dettagli',
    nessunoTitolo: 'Nessun evento',
    nessunoTesto: 'Nessun evento corrisponde ai filtri.',
    verifica: 'Verifica la catena',
    verificaInCorso: 'Verifica in corso',
    integra: (n: number) => `La catena è integra: ${n} eventi verificati.`,
    integraTesto: 'Nessun evento risulta modificato o rimosso.',
    nonIntegra: 'La catena NON è integra',
    nonIntegraTesto: (id: string | null) => `Il primo evento che non torna è ${id ?? 'sconosciuto'}. Avvisa subito il responsabile tecnico e il DPO.`,
    esporta: 'Esporta CSV firmato',
    esportaTitolo: 'Esporta il registro',
    esportaTesto: 'Il file CSV porta una firma che permette di dimostrarne l’integrità. Scegli l’intervallo di date.',
    esportaConferma: 'Scarica il CSV',
    dateNonValide: 'La data finale deve essere dopo quella iniziale.',
  },

  cancellazioni: {
    intro: 'Le richieste di cancellazione dell’account inviate dai partecipanti. Approvando, i dati personali vengono resi anonimi: presenze ed esiti restano senza nome, per i crediti già riconosciuti.',
    filtro: 'Stato',
    stati: { in_attesa: 'In attesa', approvata: 'Approvata', rifiutata: 'Rifiutata' } as const,
    colonne: { chi: 'Chi', motivo: 'Motivo', richiesta: 'Richiesta il', stato: 'Stato', decisione: 'Decisione' },
    senzaMotivo: '(nessun motivo indicato)',
    approva: 'Approva',
    rifiuta: 'Rifiuta',
    approvaTitolo: (nome: string) => `Approvare la cancellazione di ${nome}?`,
    approvaTesto: 'Nome, cognome, email e codice fiscale vengono resi anonimi e l’accesso viene chiuso. Presenze, esiti e attestati già emessi restano in forma anonima. Non si può annullare.',
    rifiutaTitolo: (nome: string) => `Rifiutare la richiesta di ${nome}?`,
    rifiutaTesto: 'L’account resta attivo. La nota finisce nel registro ed è visibile al partecipante nel profilo.',
    nota: 'Nota per il registro',
    notaAiuto: 'Obbligatoria: spiega la decisione.',
    approvaConferma: 'Sì, rendi anonimo',
    rifiutaConferma: 'Sì, rifiuta',
    decisa: 'Richiesta aggiornata.',
    nessunaTitolo: 'Nessuna richiesta',
    nessunaTesto: 'Le richieste dei partecipanti compaiono qui.',
    decisaDa: (chi: string, quando: string) => `${chi} · ${quando}`,
    annulla: 'Annulla',
  },

  utente: {
    torna: 'Utenti',
    anagrafica: 'Anagrafica',
    codiceFiscale: 'Codice fiscale',
    codiceFiscaleAiuto: 'In chiaro solo qui: la consultazione finisce nel registro.',
    totp: 'Secondo fattore',
    totpAttivo: 'Attivo',
    totpNonAttivo: 'Non attivo',
    ultimoAccesso: 'Ultimo accesso',
    creato: 'Account creato',
    mai: 'Mai',
    modifica: 'Modifica',
    modificaTitolo: 'Modifica l’anagrafica',
    modificaTesto: 'Il codice fiscale non si modifica da qui: in caso di errore, annulla l’iscrizione e importa di nuovo.',
    motivo: 'Motivo della modifica',
    motivoAiuto: 'Obbligatorio: va nel registro eventi.',
    salva: 'Salva le modifiche',
    salvato: 'Anagrafica aggiornata.',
    sospendi: 'Sospendi',
    riattiva: 'Riattiva',
    sospendiTitolo: (nome: string) => `Sospendere ${nome}?`,
    sospendiTesto: 'Non potrà più accedere finché non viene riattivato. Iscrizioni e dati restano.',
    riattivaTitolo: (nome: string) => `Riattivare ${nome}?`,
    riattivaTesto: 'Potrà accedere di nuovo con le sue credenziali.',
    motivoSospensione: 'Motivo',
    sospeso: 'Account sospeso.',
    riattivato: 'Account riattivato.',
    storico: 'Storico',
    iscrizioni: 'Iscrizioni ai percorsi',
    nessunaIscrizione: 'Nessuna iscrizione.',
    webinar: 'Webinar',
    nessunWebinar: 'Nessun webinar.',
    colonne: { webinar: 'Webinar', data: 'Data', conferma: 'Conferma', modalita: 'Modalità', minuti: 'Minuti', percentuale: 'Presenza', test: 'Test', attestato: 'Attestato' },
    esportaCsv: 'Esporta CSV',
    esitiTest: { in_corso: 'In corso', superato: 'Superato', non_superato: 'Non superato', scaduto: 'Scaduto' } as Record<string, string>,
  },

  tuoiDati: {
    titolo: 'I tuoi dati',
    intro: 'Puoi scaricare tutto ciò che Aulaviva conserva su di te oppure chiedere la cancellazione dell’account.',
    scarica: 'Scarica i tuoi dati',
    scaricaAiuto: 'Un file JSON con anagrafica, iscrizioni, presenze, esiti dei test, attestati e domande.',
    chiedi: 'Chiedi la cancellazione dell’account',
    chiediTitolo: 'Chiedere la cancellazione?',
    chiediTesto: 'L’organizzatore valuta la richiesta. Se la approva, nome, email e codice fiscale vengono resi anonimi e non potrai più accedere; presenze ed esiti già maturati restano in forma anonima per i crediti già riconosciuti.',
    motivo: 'Motivo (facoltativo)',
    password: 'La tua password, per conferma',
    conferma: 'Invia la richiesta',
    inviata: 'Richiesta inviata: l’organizzatore ti risponderà.',
    statoTitolo: 'Richiesta di cancellazione',
    stati: { in_attesa: 'In attesa della decisione dell’organizzatore', approvata: 'Approvata', rifiutata: 'Rifiutata dall’organizzatore' } as const,
    richiestaIl: (quando: string) => `Inviata il ${quando}.`,
    passwordErrata: 'La password non corrisponde.',
  },
};
